import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const KEY = "parlaylab_install_dismissed";
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export function InstallBanner() {
  const { user } = useAuth();
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY)) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);
  if (!user || !show) return null;
  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };
  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") dismiss();
  };
  return (
    <div data-testid="install-banner" className="border-b border-emerald-500/30 bg-emerald-500/10">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 py-2 text-xs text-emerald-100 sm:px-6 lg:px-8">
        <Download size={14} className="text-emerald-400" />
        <span className="min-w-0 flex-1">
          {prompt ? "Add The Parlay Lab to your home screen — full-screen app, no app store needed, push alerts included." : <>Install on iPhone: tap <Share size={12} className="inline -mt-0.5" /> Share, then <b>Add to Home Screen</b>. No app store needed.</>}
        </span>
        {prompt && <button data-testid="install-btn" onClick={install} className="btn-primary !px-3 !py-1 text-[11px]">Install</button>}
        <button data-testid="install-dismiss" onClick={dismiss} className="rounded p-1 text-emerald-200/70 hover:text-white" aria-label="Dismiss"><X size={14} /></button>
      </div>
    </div>
  );
}
